import React from 'react'
import { connect } from 'react-redux'
import TransactionsHistory from '../../components/history/transactions'

const compare = (obj, id1, id2) => {
  if (obj[id1].time < obj[id2].time) return 1
  if (obj[id1].time > obj[id2].time) return -1
  return 0
}

const mapStateToProps = (state) => ({
  ...state.transactionsHistory,
  sortedTransactionIds: state.entities.transactions.allIds.sort(
    compare.bind(null, state.entities.transactions)
  ),
  transactions: state.entities.transactions,
  refundDisabled: state.transactionsHistory.refundDisabled,
  summaryReport: state.entities.summaryReport,
  alert: state.transactionsHistory.alert
})

const mapDispatchToProps = (dispatch) => ({
  onChangeDate: (date) =>
    dispatch({ type: 'TRANSACTIONS_HISTORY_DATE_CHANGED', payload: { date } }),
  onChangeSearch: (e) =>
    dispatch({
      type: 'TRANSACTIONS_HISTORY_SEARCH_CHANGED',
      payload: { searchString: e.target.value }
    }),
  onRefundPayment: () => dispatch({ type: 'TRANSACTIONS_HISTORY.REFUND_PAYMENT' }),
  onRefundReceipt: () => dispatch({ type: 'TRANSACTIONS_HISTORY.REFUND_RECEIPT' }),
  onClickTransaction: (id, refundDisabled) =>
    dispatch({ type: 'TRANSACTIONS_HISTORY_ITEM_CLICKED', payload: { id, refundDisabled } }),
  onClickReceipt: () => dispatch({ type: 'TRANSACTIONS_HISTORY_RECEIPT' }),
  onCleanAlert: () => dispatch({ type: 'TRANSACTIONS_HISTORY.CLEAN_ALERT' }),
  onSubmitSearch: (e) => {
    e.preventDefault()
    dispatch({ type: 'TRANSACTIONS_HISTORY_SEARCH_SUBMITTED' })
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsHistory)
